import Character from "../Character";

/**
 * @abstract
 */
export default class TurnAction {
    constructor() {        
    }   

    /**
     * Invoked for a character once per frame.
     * @abstract
     * @param {Character} character The character making the turn action.
     * @param {number} frameTimeRatio The time frame ratio.
     * @param {boolean} turnStart True if this is the start of a turn.
     */
    performAction(character, frameTimeRatio, turnStart) {}

    /**
     * Returns true if this turn action will move the character and affect the path plan.
     * @abstract
     * @returns {boolean}
     */
    isMovementAction() {
        return false;
    }

    /**
     * @abstract
     * @returns {string}
     */
    toString() {
        return 'BaseTurnAction';
    }
}